import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// The build is pre-rendered to static HTML (see scripts/prerender.js) so that
// AI crawlers and search bots receive real, fully-rendered page content without
// executing JavaScript. In the browser we mount a fresh client root over that
// markup — React replaces the static HTML with the live, interactive app.
// (We intentionally do NOT hydrate: the snapshot is captured client-side DOM,
// which lacks the SSR text-boundary markers hydrateRoot requires.)
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
